// extracted by mini-css-extract-plugin
export var avatar = "Speakers-module--avatar--fe5c9";
export var card = "Speakers-module--card--3b1bb";
export var companyName = "Speakers-module--companyName--10868";
export var content = "Speakers-module--content--74078";
export var contentWrapper = "Speakers-module--contentWrapper--e8d96";
export var description = "Speakers-module--description--fbbc5";
export var descriptionText = "Speakers-module--descriptionText--ee23f";
export var jobDescription = "Speakers-module--jobDescription--c2519";
export var media = "Speakers-module--media--e7f49";
export var speakerDetails = "Speakers-module--speakerDetails--daa5b";
export var speakerInfo = "Speakers-module--speakerInfo--52241";
export var speakerName = "Speakers-module--speakerName--6ea65";
export var title = "Speakers-module--title--17dcf";
export var wrapper = "Speakers-module--wrapper--832a0";